const asyncWrapper = async <T = void>(
  procedure: () => Promise<T>,
): Promise<T> => {
  try {
    return await procedure();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default asyncWrapper;
